export const environment = {
production: false,
enable_test_ui: false,
  base_url: 'https://api.payarc.net/v1'
};
